/**
 * @file: FloatingChatHost.tsx
 *
 * Renders the docked floating chat panel INSIDE the navigation container — the
 * chat conversation's coordinator calls `useNavigation` (to open cards / deep
 * links), so the panel can't live above the navigator. Mounted by the routes;
 * reads the open conversation off `FloatingChatProvider` (an app-wide ancestor).
 */

import { FC, memo } from 'react';
import { FloatingChatPanel } from './FloatingChatPanel';
import { useFloatingChat } from './context';

export const FloatingChatHost: FC = memo(() => {
  const { active$ } = useFloatingChat();
  return <FloatingChatPanel active$={active$} />;
});
